export default function Header() {
  return (
    <div className="mb-6">
      <h1 className="text-2xl md:text-3xl font-semibold text-slate-900">
        User Onboarding
      </h1>
      <p className="mt-1 text-sm text-slate-500">
        Verify your GST, bank details and sign the agreement to complete your
        setup.
      </p>
    </div>
  );
}